import React from 'react';
import { Card, Table } from 'react-bootstrap';
import { formatPhone, formatDate } from '../../utils/formatters';

const CustomerDetailCard = ({ customer, serviceAddress }) => {
  return (
    <Card className="shadow mb-4">
      <Card.Header>
        <h3 className="mb-0">Customer Detail</h3>
      </Card.Header>
      <Card.Body>
        <Table size="sm" className="detail-table mb-0">
          <tbody>
            <tr>
              <th>Name</th>
              <td>{customer?.firstName} {customer?.lastName}</td>
            </tr>
            <tr>
              <th>Co-Customer Names</th>
              <td>
                {customer?.coCustomerNames?.length > 0
                  ? customer.coCustomerNames.join(', ')
                  : <span className="text-muted">None</span>}
              </td>
            </tr>
            <tr>
              <th>Service Address</th>
              <td>{serviceAddress}</td>
            </tr>
            <tr>
              <th>Language Preference</th>
              <td>{customer?.languagePreference || <span className="text-muted">N/A</span>}</td>
            </tr>
            <tr>
              <th>Phone Numbers</th>
              <td>
                {customer?.phoneNumbers?.length > 0
                  ? customer.phoneNumbers.map(p => formatPhone(p)).join(', ')
                  : <span className="text-muted">None</span>}
              </td>
            </tr>
            <tr>
              <th>Email</th>
              <td>{customer?.email || <span className="text-muted">None</span>}</td>
            </tr>
            <tr>
              <th>Date of Birth</th>
              <td>{customer?.dateOfBirth ? formatDate(customer.dateOfBirth) : <span className="text-muted">N/A</span>}</td>
            </tr>
            <tr>
              <th>Housing Status</th>
              <td>{customer?.housingStatus || <span className="text-muted">N/A</span>}</td>
            </tr>
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export default CustomerDetailCard;
